// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".click-more[data-v-d96db30e]{text-align:center;width:100%;padding-top:12Px;padding-bottom:8Px}", ""]);
// Exports
module.exports = exports;
